import { toast } from "react-toastify";

import { validatePedidoIntegracaoReportPeriod } from "../../../utils/pedidoIntegracaoReportPeriod";

/** Retorna `true` se o período for inválido (e exibe toast de aviso). */
export function warnIfReportPeriodInvalid(
  dataInicio: string,
  dataFim: string
): boolean {
  const err = validatePedidoIntegracaoReportPeriod(dataInicio, dataFim);
  if (err) {
    toast.warning(err);
    return true;
  }
  return false;
}
